import { DropPointDto } from '~/lib';
import { Store } from '~/lib/data-contract/salesforce';
import { MapMarker } from '../models';

type LocationTypes = DropPointDto | Store;

const isStore = (location: LocationTypes): location is Store => {
    return (location as Store)._type === 'store';
};
const isDroppoint = (location: LocationTypes): location is DropPointDto => {
    return (location as DropPointDto)?.dropPointId !== undefined;
};

export const generateMapMarkers = (locations?: DropPointDto[] | Store[] | null) => {
    if (!locations) return null;

    return locations.map((location) => {
        const { latitude, longitude, ...rest } = location;
        const id = isStore(location) ? location.id : `${latitude}${longitude}`;
        return {
            ...rest,
            lat: latitude,
            lng: longitude,
            _id: id,
            ...(isDroppoint(location) && { _type: 'droppoint' }),
        } as MapMarker;
    });
};
